import { Routes, Route } from "react-router-dom";
import Terms from "./Pages/Terms/terms";
import Privacy from "./Pages/Terms/privacy";
import Home from "./Pages/Home/Home";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}
export default App;
